import { useQuery } from "@tanstack/react-query";
import { Link2 } from "lucide-react";
import { http } from "../api/http";
import { useAuthStore } from "../store/auth";
export type TeamReference = { entityType: string; entityId: string };
export function TeamReferences({
  references,
  onOpen,
}: {
  references: TeamReference[];
  onOpen: (kind: "notes" | "meetings" | "boards", id: string) => void;
}) {
  const user = useAuthStore((s) => s.user);
  const q = useQuery({
    queryKey: ["team-references", user?.id, references],
    queryFn: async () =>
      (
        await http.post<{
          items: (TeamReference & { available: boolean; label?: string })[];
        }>("/v1/workspace/references/resolve", {
          references: references.map(({ entityType, entityId }) => ({
            entityType,
            entityId,
          })),
        })
      ).data,
    enabled: references.length > 0,
    gcTime: 0,
    refetchInterval: 10000,
    retry: false,
  });
  if (!references.length) return null;
  const kinds: Record<string, "notes" | "meetings" | "boards"> = {
    NOTE: "notes",
    MEETING: "meetings",
    BOARD: "boards",
  };
  return (
    <section aria-label="Objets liés" className="space-y-2">
      <h3 className="text-eyebrow uppercase text-secondary">Objets liés</h3>
      {q.isError ? (
        <p className="text-sm text-secondary">Vérification indisponible.</p>
      ) : q.isFetching ? (
        <p className="text-sm text-secondary">Vérification…</p>
      ) : (
        <div className="flex flex-wrap gap-2">
          {q.data?.items?.map((r) =>
            r.available && kinds[r.entityType] ? (
              <button
                key={r.entityType + r.entityId}
                type="button"
                className="inline-flex h-9 items-center gap-1.5 rounded-pill bg-primary-50 px-3.5 text-[13px] font-medium text-primary-700 transition-colors hover:bg-primary-100"
                onClick={() => onOpen(kinds[r.entityType], r.entityId)}
              >
                <Link2 size={14} aria-hidden />
                {r.label}
              </button>
            ) : (
              <span
                key={r.entityType + r.entityId}
                className="inline-flex h-9 items-center rounded-pill bg-surface-2 px-3.5 text-[13px] text-secondary"
              >
                Dossier indisponible ou non autorisé
              </span>
            ),
          )}
        </div>
      )}
    </section>
  );
}
